import * as search from './search/SearchActions';
import * as settings from './settings/SettingsActions';
import * as templates from './templates/TemplatesActions';

const actions = { ...search, ...settings, ...templates };
export default actions;
